import { Base } from '@studiometa/js-toolkit';

/**
 * QuickBuy class.
 */
export default class QuickBuy extends Base {
  sectionId = 'section-quickbuy';

  static config = {
    name: 'QuickBuy',
    refs: ['loader', 'icon'],
    options: {
      productHandle: String,
    },
  };

  /**
   * Click on Button and emit event
   */
  onClick() {
    this.$refs.icon.classList.add('hidden');
    this.$refs.loader.classList.remove('hidden');
    fetch(`/products/${this.$options.productHandle}?section_id=${this.sectionId}`)
      .then((response) => response.text())
      .then((text) => {
        if (text.toLowerCase().includes('fail')) {
          this.$refs.loader.classList.add('hidden');
          this.$refs.icon.classList.remove('hidden');

          this.$root.Toaster.addToast(
            "Le serveur a renvoyé une réponse d'erreur. Veuillez réessayer plus tard.",
          );
          return;
        }

        const event = new CustomEvent('open-panel', { detail: [text], bubbles: true });
        document.dispatchEvent(event);

        this.$refs.loader.classList.add('hidden');
        this.$refs.icon.classList.remove('hidden');
        this.$root.$update();
      })
      .catch((e) => {
        this.$refs.loader.classList.add('hidden');
        this.$refs.icon.classList.remove('hidden');
        this.$root.Toaster.addToast(e);
      });
  }
}
